import React, { Fragment, useEffect, useState } from "react";
import { Col, Row } from "reactstrap";

import { PageWrapper } from "../components/PageWrapper/PageWrapper";
import { NotificationsCard } from "../components/NotificationsCard/NotificationsCard";

export const Notifications = () => (
  <PageWrapper title="Notificaciones">
    <NotificationsCard />
  </PageWrapper>
);
